import { DialogModule, DialogRef } from '@angular/cdk/dialog';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output
} from '@angular/core';

import { ComponentType, ConnectedPosition } from '@angular/cdk/overlay';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonInstance, JepLayer } from '@jeppesen-foreflight/jmkw-types';
import { ButtonComponent } from '../../base/button/button.component';
import { AbstractButton } from '../../typings/abstract-button';
import { PopoutService } from './popout.service';

@Component({
  selector: 'jmkw-popout-button',
  standalone: true,
  imports: [ButtonComponent, DialogModule],
  templateUrl: './popout-button.component.html',
  styleUrls: ['./popout-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoutButtonComponent extends AbstractButton {
  private readonly _popoutService = inject(PopoutService);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _cdf = inject(ChangeDetectorRef);

  private _dialogRef?: DialogRef<any, any>;

  // Interface properties that can be passed as inputs
  @Input() iconName?: string;
  @Input() buttonText?: string;
  @Input() tooltipText = '';
  @Input() automationKey?: string;

  // PopoutButton-specific @Input properties
  @Input() positions?: ConnectedPosition[];
  @Input() stateFn?: (button: ButtonInstance, layer: JepLayer) => void;
  @Input() contentComponent?: ComponentType<any>;
  @Output() dialogOpened = new EventEmitter<DialogRef<any, any>>();
  @Output() dialogClosed = new EventEmitter<void>();
  @Output() onClick = new EventEmitter<MouseEvent>();

  onClickHandler(e: MouseEvent, button: ButtonComponent) {
    this.onClick.emit(e);
    if (this.contentComponent) {
      this._dialogRef = this._popoutService.openPopout(
        button,
        this.contentComponent,
        this.positions
      );

      this.hover = true;
      this.dialogOpened.emit(this._dialogRef);

      this._dialogRef.closed
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(() => {
          this.hover = false;
          this._cdf.markForCheck();
          this.dialogClosed.emit();
        });
    }
  }
}
